import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './AvailabilityForm.jsx'

export default createSubmit(name)